import { render, staticRenderFns } from "./report-interaction-tab.vue?vue&type=template&id=46f56ae2&"
import script from "./report-interaction-tab.vue?vue&type=script&lang=js&"
export * from "./report-interaction-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports